"use client";

import type { FC } from "react";
import { useAuth } from "@huub-web/backend";

import { useAppointments } from "../../hooks/useAppointments";
import { VideoCall } from "../VideoCall/VideoCall";

/**
 * Controller component that manages the video call state and renders the VideoCall component
 * when a call is active
 */
export const VideoCallController: FC = () => {
  const { isVideoCallActive, endVideoCall } = useAppointments();
  const { indentity } = useAuth();

  if (!isVideoCallActive) {
    return null;
  }

  const handleEndVideoCall = () => {
    endVideoCall();
  };

  return (
    isVideoCallActive && (
      <VideoCall
        appID={"vpaas-magic-cookie-3d6a553803674e87988f292654e8a436"}
        userInfo={{
          displayName: indentity?.name,
          email: indentity?.email,
        }}
        onClose={handleEndVideoCall}
      />
    )
  );
};
